import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as payActions } from "../../redux/modules/pay";
import { actions as userActions } from "../../redux/modules/user";
import { getQueryValue, isWechat } from "../../utils/tool";
import BuyNow from "./components/BuyNow";
import PayNow from "./components/PayNow";
import PayErrorTip from "./components/PayErrorTip";
import { get } from "../../utils/request";
import "./style.css";

class Pay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
      isWechat: false,
      msg: "",
    };
  }
  componentDidMount = () => {
    if (isWechat()) {
      if (getQueryValue("code") === null) {
        var redirect_uri =
          window.location.protocol + "//" + window.location.host + "/pay";
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815e5cbaca96433f&redirect_uri=" +
          redirect_uri +
          "&response_type=code&scope=snsapi_base&#wechat_redirect";
      } else {
        var code = getQueryValue("code");
        this.setState({
          code: code,
          isWechat: true,
        });
        //this.requestUserInfo();
      }
    } else {
      this.setState({
        code: "",
        isWechat: false,
      });
    }
  };
  render() {
    const { showPay } = this.props.uiPay;
    const { discounts } = this.props.userInfo;
    return (
      <div>
        <img
          alt=""
          style={{ outlineWidth: "0px", verticalAlign: "top", width: "100%" }}
          src={require("../../images/dayup/order/pay0.png")}
        ></img>
        {/* <img
          alt=""
          style={{ outlineWidth: "0px", verticalAlign: "top", width: "100%" }}
          src={require("../../images/dayup/order/详情页2.jpg")}
        ></img>
        <img
          alt=""
          style={{ outlineWidth: "0px", verticalAlign: "top", width: "100%" }}
          src={require("../../images/dayup/order/详情页3.jpg")}
        ></img> */}
        <div style={{ height: "90px" }}></div>
        <BuyNow
          visible={!showPay}
          handleShowAndClosePayNow={this.handleShowAndClosePayNow}
          discounts={discounts}
        ></BuyNow>
        <PayNow
          discounts={discounts}
          visible={showPay}
          handleShowAndClosePayNow={this.handleShowAndClosePayNow}
          requestPay={this.requestPay.bind(this)}
        ></PayNow>
        {this.state.msg ? (
          <PayErrorTip
            handleClosePayErrorTip={this.handleClosePayErrorTip}
            msg={this.state.msg}
          ></PayErrorTip>
        ) : null}
      </div>
    );
  }

  /**
   * 关闭微信错误提示框
   */
  handleClosePayErrorTip = () => {
    this.setState({
      msg: "",
    });
  };

  /**
   * 显示和关闭支付框
   */
  handleShowAndClosePayNow = () => {
    const { dispatch } = this.props;
    if (!isWechat()) {
      this.setState({
        msg: "请在微信中打开",
      });
    } else {
      if (this.props.userInfo.isLogin) {
        dispatch(payActions.setShowPay(!this.props.uiPay.showPay));
      } else {
        dispatch(userActions.setShowLogin(true));
      }
    }
  };

  /**
   * 请求用户信息
   */
  requestUserInfo = () => {
    get("/public/v1/user/info").then((res) => {
      if (
        (res.status === "fail" && res.data.err_code === 20003) ||
        res.data.err_code === 10002
      ) {
        const { dispatch } = this.props;
        dispatch(userActions.setShowLogin(true));
      }
    });
  };
  /**
   * 请求支付
   */
  requestPay = (payType) => {
    get("/api/pay/get/openid/" + this.state.code).then((res) => {
      if (res.status === "success") {
        get("/api/pay/" + payType).then((res) => {
          if (res.status === "success" && res.data !== "完全抵扣") {
            res = res.data;
            window.wx.config({
              debug: false,
              appId: res.appId,
              timestamp: res.timeStamp,
              nonceStr: res.nonceStr,
              signature: res.paySign,
              jsApiList: ["chooseWXPay"],
            });
            //成功执行的方法
            window.wx.ready(function () {
              window.wx.chooseWXPay({
                timestamp: res.timeStamp,
                nonceStr: res.nonceStr,
                package: res.package,
                signType: res.signType,
                paySign: res.paySign,
                success: function (res) {
                  window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    "/dayup";
                },
              });
            });
            window.wx.error(function (res) {
              alert("支付异常,请联系管理员!");
            });
          } else if (res.status === "success" && res.data === "完全抵扣") {
            window.location.href =
              window.location.protocol + "//" + window.location.host + "/dayup";
          }
        });
      }
    });
  };
}

const mapStateToProps = (state) => {
  return {
    uiPay: state.pay.uiStateData,
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(Pay);



// WEBPACK FOOTER //
// ./src/containers/Pay/index.js